const translations = {
    cancel: 'Cancel',
    createAnInvoice: 'Create an Invoice',
    noChangesToSave: 'There are no changes to be saved.',
    review: 'Review',
    save: 'Save'
};

export default translations;
